import { COLOR_MAP } from './constants';

const getColorByType = type => COLOR_MAP[type] || COLOR_MAP['default'];

export { getColorByType };
